var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.returnUrl) ? _c('link-button', {
    ref: "button",
    attrs: {
      "icon": _vm.icon,
      "size": _vm.size,
      "to": {
        path: _vm.returnUrl
      },
      "type": _vm.type
    }
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.textOrDefault))])], 2) : _c('common-button', {
    ref: "button",
    attrs: {
      "icon": _vm.icon,
      "size": _vm.size,
      "type": _vm.type
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.textOrDefault))])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-151946c7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/CancelButton.vue
// module id = 1870
// module chunks = 0